import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-16 pt-10 md:pt-16" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "font-mono-label text-xs uppercase tracking-[0.18em] text-subtle mb-6" }, " Perfil profesional · San Salvador, El Salvador ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "font-serif-display text-5xl md:text-7xl leading-[0.98] tracking-tight text-ink mb-3" }, [
  /*#__PURE__*/_createTextVNode(" Juan Alonso"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Rodríguez ")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "font-serif-display italic text-2xl md:text-3xl text-indigo2 inline-block border-b-2 border-indigo2 pb-1 mb-8" }, " Java Backend Developer ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-subtle text-lg leading-relaxed max-w-[54ch] mb-10" }, " Construyo y mantengo los sistemas backend de la banca salvadoreña: procesamiento por lotes, facturación electrónica y APIs REST sobre Spring Boot, con SOAP y JMS/MQ para las integraciones que nadie ve pero todos necesitan. ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("a", {
  href: "#contact",
  class: "text-indigo2 font-semibold border-b border-indigo2 pb-0.5 hover:opacity-75 transition-opacity"
}, " Contáctame → ", -1)


export default /*#__PURE__*/_defineComponent({
  __name: 'BannerPrincipal',
  setup(__props) {

const cvUrl = `${process.env.BASE_URL}cv/CV-Juan-Alonso-Rodriguez.pdf`;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _createElementVNode("div", { class: "flex flex-wrap items-center gap-8" }, [
      _hoisted_6,
      _createElementVNode("a", {
        href: cvUrl,
        download: "",
        class: "text-ink font-semibold border-b border-ink pb-0.5 hover:opacity-75 transition-opacity"
      }, " Descargar CV ")
    ])
  ]))
}
}

})